import { render, staticRenderFns } from "./valora.vue?vue&type=template&id=16e0dea0&"
import script from "./valora.vue?vue&type=script&lang=js&"
export * from "./valora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports